/**
 * Motion tokens for JS (Motion `m.*` props, timers). The CSS side lives in index.css
 * (`--dur-*`, `ease-*`, `animate-*`); both come from docs/DESIGN.md section 7. Keep in sync.
 */
export const dur = {
	instant: 0.1,
	quick: 0.16,
	base: 0.24,
	slow: 0.38,
	feed: 0.52,
} as const

export const ease = {
	/** Default for anything entering or moving ("glide"). */
	out: [0.22, 1, 0.36, 1],
	/** Things travelling across the screen ("shuttle"). */
	inOut: [0.65, 0, 0.35, 1],
	/** Print-out and hero moments ("feed"). */
	feed: [0.16, 1, 0.3, 1],
	/** Entrances of small things only: badge, check, toggle. Never on close. */
	pop: [0.34, 1.36, 0.64, 1],
} as const

/** Drag, reorder, flashcards. */
export const spring = { type: 'spring', stiffness: 420, damping: 38, mass: 0.9 } as const

/** Lists: stagger on first mount only, 30ms per item, at most 8 items staggered. */
export const stagger = (i: number) => (Math.min(i, 7) * 30) / 1000

export const prefersReducedMotion = () =>
	typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
